<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />
    <BankDeposits />
  </Layout>
</template>

<script>
import Layout from '@/views/Layout'
import BankDeposits from '@/components/Reports/BankDeposits'

export default {
  name: 'ReportsBankDepositsView',
  components: {
    Layout,
    BankDeposits
  },
  computed: {
    breadcrumbs: () => [
      {
        text: 'Inicio',
        to: { name: 'HomeIndex' }
      },
      {
        text: 'Relatorios',
        to: { name: 'ReportsIndex' }
      },
      {
        text: 'Depositos bancarios',
        to: { name: 'ReportBankDeposits' },
        active: true
      }
    ]
  }
}
</script>
